import React from "react";
import PropTypes from "prop-types";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";
import Tag from "@amzn/meridian/tag";
import Box from "@amzn/meridian/box";
import {FormattedMessage} from "react-intl";
import {CART_FILTER_PANEL_STRINGS} from "../../util/Constants";

const CartFilterPanel = ({percentileThreshold, isFiltered, onToggleFilter, matchCount, totalCount}) => (
    <Box type="outline" spacingInset="medium">
        <Row alignmentVertical="center" spacing="medium">
            <Button
                type={isFiltered ? "primary" : "secondary"}
                size="small"
                onClick={onToggleFilter}
                aria-pressed={isFiltered}
                aria-label={CART_FILTER_PANEL_STRINGS.TOGGLE_FILTER_ARIA_DEFAULT}
            >
                {isFiltered
                    ? <FormattedMessage id={CART_FILTER_PANEL_STRINGS.SHOW_ALL}
                        defaultMessage={CART_FILTER_PANEL_STRINGS.SHOW_ALL_DEFAULT}/>
                    : <FormattedMessage id={CART_FILTER_PANEL_STRINGS.SELECT_BOTTOM}
                        defaultMessage={CART_FILTER_PANEL_STRINGS.SELECT_BOTTOM_DEFAULT}
                        values={{threshold: percentileThreshold}}/>
                }
            </Button>
            <Tag type="theme">
                {isFiltered
                    ? <FormattedMessage id={CART_FILTER_PANEL_STRINGS.CART_COUNT_FILTERED}
                        defaultMessage={CART_FILTER_PANEL_STRINGS.CART_COUNT_FILTERED_DEFAULT}
                        values={{matchCount, totalCount}}/>
                    : <FormattedMessage id={CART_FILTER_PANEL_STRINGS.CART_COUNT}
                        defaultMessage={CART_FILTER_PANEL_STRINGS.CART_COUNT_DEFAULT}
                        values={{matchCount, totalCount}}/>
                }
            </Tag>
            {!isFiltered && (
                <Text type="b200">
                    <FormattedMessage id={CART_FILTER_PANEL_STRINGS.PERCENTILE_THRESHOLD}
                        defaultMessage={CART_FILTER_PANEL_STRINGS.PERCENTILE_THRESHOLD_DEFAULT}
                        values={{threshold: percentileThreshold}}/>
                </Text>
            )}
        </Row>
    </Box>
);

CartFilterPanel.propTypes = {
    percentileThreshold: PropTypes.number,
    isFiltered: PropTypes.bool,
    onToggleFilter: PropTypes.func.isRequired,
    matchCount: PropTypes.number,
    totalCount: PropTypes.number
};

CartFilterPanel.defaultProps = {
    percentileThreshold: 0,
    isFiltered: false,
    matchCount: 0,
    totalCount: 0
};

export default React.memo(CartFilterPanel);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontrollerstag/CartFilterPanel.js